import { DNOBookJobSiteInfoWorkflowFactory } from "../factories/SiteTypeBookJobSiteInfoWorkflowFactories/DNOBookJobSiteInfoWorkflowFactory";
import { BNOBookJobSiteInfoWorkflowFactory } from "../factories/SiteTypeBookJobSiteInfoWorkflowFactories/BNOBookJobSiteInfoWorkflowFactory";
import { NHHBookJobSiteInfoWorkflowFactory } from "../factories/SiteTypeBookJobSiteInfoWorkflowFactories/NHHBookJobSiteInfoWorkflowFactory";
import { HHBookJobSiteInfoWorkflowFactory } from "../factories/SiteTypeBookJobSiteInfoWorkflowFactories/HHBookJobSiteInfoWorkflowFactory";
import { SubMeterBookJobSiteInfoWorkflowFactory } from "../factories/SiteTypeBookJobSiteInfoWorkflowFactories/SubMeterBookJobSiteInfoWorkflowFactory";
import { GenericBookJobSiteInfoWorkflowFactory } from "../factories/GenericBookJobSiteInfoWorkflowFactory";

export const useDetermineSiteInfoWorkflow = (mpan: string, serviceLine: string) => {
    if(serviceLine === "DNO") {
        return new DNOBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    } else if(serviceLine === "BNO") {
        return new BNOBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    } else if(serviceLine === 'NHH' || serviceLine === 'MSS' || serviceLine === 'MSA') {
        return new NHHBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    } else if(serviceLine === 'HH') {
        return new HHBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    } else if(serviceLine === 'SUBMETER') {
        return new SubMeterBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    } else {
        return new GenericBookJobSiteInfoWorkflowFactory(mpan, serviceLine);
    }
}
